module.exports = __webpack_public_path__ + "img/f_25_06.67f858be.jpg";